const initialState = null;

const selectedBonus = (state, action) => {
  if (state === undefined) {
    return initialState;
  }

  switch (action.type) {
    case 'SET_SELECTED_BONUS':
      return action.payload;
    case 'RESET_SELECTED_BONUS':
      return initialState;
    default:
      return state.selectedBonus ?? initialState;
  }
};

export { selectedBonus };
